import { colors, type } from '../theme';

/** A plain card with a title and one line, for the states no artboard draws. */
export function Card({ title, body }: { title: string; body: string }) {
  return (
    <div
      style={{
        background: colors.card,
        border: `1px solid ${colors.line}`,
        borderRadius: 16,
        padding: '18px 20px',
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
      }}
    >
      <div style={{ ...type.cardTitle, color: colors.navy }}>{title}</div>
      <p style={{ ...type.body, color: colors.mutedInk, margin: 0 }}>{body}</p>
    </div>
  );
}
